import React, {useEffect, useState} from "react";
import $ from 'jquery';
import {useLocation, useNavigate, useParams} from "react-router-dom";
import {useSelector} from "react-redux";
import axios from "axios";
import "../../assets/css/pages/orders.css";
import avatarBlank from "../../assets/media/svg/avatar-blank.svg";
import _ from "lodash";
import swal from "sweetalert";
import {confirmAlert, errorAlert} from "../../Components/Alerts/BasicAlert";
import {downloadBlob} from "../../Components/Helpers/Utils";
import dayjs from "dayjs";
import {DATE_FORMAT} from "../../Constants/Constants";
import ReactSelectInput from "../../Components/Inputs/ReactSelectInput";
import {useForm} from "react-hook-form";
import DateInput from "../../Components/Inputs/DateInput";
import ReactMultiSelectInput from "../../Components/Inputs/ReactMultiSelectInput";

const endDate = dayjs();
const startDate = endDate.startOf('month');

export default function () {
  const location = useLocation();

  const ordersFilters = location.state;

  const {register, control, watch, getValues} = useForm({
    defaultValues: {
      status: ordersFilters?.status ? ordersFilters?.status : "",
      payment_status: ordersFilters?.payment_status ? ordersFilters?.payment_status : "",
      // date_from: ordersFilters?.date_from ? ordersFilters?.date_from : startDate.format(DATE_FORMAT),
      // date_to: ordersFilters?.date_to ? ordersFilters?.date_to : endDate.format(DATE_FORMAT),
      date_from: startDate.format(DATE_FORMAT),
      date_to: endDate.format(DATE_FORMAT),
      shops: ordersFilters?.shops ? ordersFilters?.shops : [],
    }
  });

  const navigate = useNavigate();
  const token = useSelector(state => state.token);
  const user = useSelector(state => state.user);
  const isAdmin = user?.roles?.includes('Super Admin');
  const {status} = useParams();

  const [data, setData] = useState({});
  const [statusState, setStatusState] = useState();
  const [shopState, setShopState] = useState();
  const [statuses, setStatuses] = useState([]);
  const [bulkArray, setBulkArray] = useState([]);
  const buttonIsDisabled = !bulkArray.length;
  var filters;


  useEffect(() => {
    const baseUrl = process.env.REACT_APP_API_URL;
    filters = {...getValues()};
    if (status) {
      filters.status = status;
    }

    setStatusState(filters.status);
    setShopState(filters.shops);

    let table = $('#orders').DataTable({
      "destroy": true,
      "ajax": {
        url: `${baseUrl}orders`,
        data: filters,
        beforeSend: function (request) {
          request.setRequestHeader("Authorization", 'Bearer ' + token);
        },
        error: function (xhr) {
          if (xhr?.status === 401) {
            axios.post('/logout')
              .then(res => {
                localStorage.removeItem('persist:root');
                navigate('/login');
              });
          }
        }
      },
      "columns": [
        {
          data: 'checkbox',
          orderable: false,
          searchable: false,
          render: function (data, type, row) {
            return `
                    <label class="form-label-checkbox fs-6 fw-bolder text-dark">
                      <input class="checkbox list" type="checkbox" label="My Value" name="primary" row-id="${row.id}">
                      <span class="checkmark"></span>
                    </label>
                    `;
          },
        },
        {data: 'id', name: 'id'},
        {
          data: 'user.first_name',
          name: 'user.first_name',
          orderable: true,
          render: function (data, type, row) {
            let img = row?.user?.image?.url || avatarBlank;

            return `<div class="image" row-user-id="${row?.user_id}" title="Open customer details" style="background: url(${img});"></div>
                    <div class="customer-status" title="${row?.user?.is_active ? "Active" : "Blocked"}">
                      <span class="${row?.user?.is_active ? "bg-success" : "bg-danger"}"></span>
                    </div>
                    <span class="customer-fullname w-auto" row-id="${row.id}" row-user-id="${row.user_id}" title="Open customer details">
                      ${row?.user?.first_name || ""} ${row?.user?.last_name || ""}
                    </span>`;
          },
        },
        {data: 'shipping_address.phone', name: 'shippingAddress.phone', orderable: false, render: function (data, type, row) {
            return row?.shipping_address?.phone || row.customer_address?.phone;
          },
        },
        {data: 'user.email', name: 'user.email'},
        {
          data: 'status',
          searchable: false,
          orderable: true,
          render: function (data, type, row) {
            let badgeObj = renderStatus(row?.status);
            return `<span class="badge ls-1 fs-7 fw-bold badge-light-${badgeObj.color}">${badgeObj.icon} ${row?.status.replaceAll('_', ' ')}</span>
            `;
          },
        },
        {
          data: 'price',
          name: 'price',
          orderable: false,
          searchable: false,
        },
        {
          data: 'created_at',
          searchable: false,
          orderable: true,
          render: function (data, type, row) {
            return `<span title="dd/mm/yyyy">${new Date(row?.created_at).toLocaleDateString('en-GB')}</span>`;
          },
        },
        {
          data: 'modified',
          searchable: false,
          orderable: false,
          render: function (data, type, row) {
            return `<div class="p-3 fs-8 text-center text-white rounded bg-${row.modified ? 'success': 'info'}">
                               ${row.modified ? 'YES' : 'NO'}
                            </div>`
          },
        },
        {
          data: 'warranty',
          orderable: false,
          searchable: false,
          render: function (data, type, row) {
            return `<div class="p-3 fs-8 text-center text-white rounded bg-${row.warranty === 'Yes' ? 'success' : 'info'}">
                               ${row.warranty}
                            </div>`
          },
        },
        {
          data: 'refundable',
          orderable: false,
          searchable: false,
          render: function (data, type, row) {
            return row.refundable ? `<button
                class="btn btn-primary me-2 mb-2 bg-black-transperent refund"
                row-id="${row.id}">
                  Refund
                </button>` : `<button
                class="btn btn-secondary me-2 mb-2 bg-black-transperent"
                disabled>
                  Refund
                </button>`;
          },
        },
        {
          data: 'actions',
          orderable: false,
          searchable: false,
          render: function (data, type, row) {
            return `<button type="button"
                        class="btn-primary me-2 mb-2 actions">
                            Actions
                            <i class="fas fa-caret-down"></i>
                    </button>
                    <div class="row-actions display-none hidden-actions">
                        <div class="absolute-div">
                            <button 
                            class="btn btn-primary me-2 mb-4 mt-1 show"
                            row-id="${row.id}">
                                <i class="fas fa-eye"></i> Show
                            </button>
                            <button 
                            class="btn btn-primary me-2 mb-1 mt-1 edit"
                            row-id="${row.id}">
                                <i class="fas fa-edit"></i> Edit
                            </button>
                        <div>
                    </div>`;
          },
        }
      ],
      "order": [[7, "desc"]],
    });

    table.off('click');

    table.on('click', 'button.actions', function () {
      $(this).next(".row-actions").fadeToggle(200).toggleClass("hidden-actions")
    });

    table.on('click', 'button.show', function () {
      const id = $(this).attr("row-id");
      navigate(`/orders/${id}`);
    });

    table.on('click', 'button.edit', function () {
      const id = $(this).attr("row-id");
      navigate(`/orders/${id}/edit`);
    });

    table.on('click', 'span.customer-fullname, div.image', function () {
      const id = $(this).attr("row-user-id");
      navigate("/customers/" + id);
    });

    //Bulk Start()
    table.on('click', '.form-label-checkbox .checkbox.list', function () {
      const id = ($(this).attr("row-id"));
      setBulkArray(cur => _.xor(cur, [id]));
    });

    table.on('click', '.form-label-checkbox .checkbox.mark-all', function () {
      if ($(this).is(':checked')) {
        setBulkArray([]);
        let allId = [];
        $(".form-label-checkbox .checkbox.list").each(function (index) {
          if ($(this).is(':checked') == false) {
            $(this).click();
          }
          allId.push($(this).attr("row-id"));
        });
        setBulkArray(allId);
      } else {
        $(".form-label-checkbox .checkbox.list").each(function (index) {
          if ($(this).is(':checked') == true) {
            $(this).click();
          }
        });
        setBulkArray([]);
      }
    });

    table.on('draw', function () {
      $(".pagination .page-item").click(function () {
        resetMarked();
      });
      resetMarked();
      $(".form-label-checkbox #mark-all").click().click();
    });


    $("table.dataTable thead tr:first-child th:nth-child(1)")
      .html(`<label class="form-label-checkbox fs-6 fw-bolder text-dark pt-0">
           <input class="checkbox mark-all" type="checkbox" id="mark-all" label="My Value" name="primary">
           <span class="checkmark"><span></span></span>
           </label>`);

    //Bulk End()
    table.on('click', 'button.refund', function () {
      const id = $(this).attr("row-id");

      confirmAlert('Do you want to refund ?', () => {
        axios.post(`/orders/${id}/refund`).then(res => {
          table.draw(false);
        }).catch(err => {
          const message = err.response?.data?.message;

          if (message) {
            errorAlert(message);
          }
        })
      });
    });

    let datatableSearch = ".dataTables_wrapper .dataTables_filter input[type=search]";
    $("<i class='fas fa-search'></i>")
      .insertBefore(datatableSearch);
    $(datatableSearch)
      .attr("placeholder", "Search...");

    //save filters start()
    let filtersForLocalStorage = filters;
    filters.status = parseInt(filtersForLocalStorage.status);
    localStorage.setItem('orders_filters', JSON.stringify(filtersForLocalStorage));
    //save filters end()

  }, [JSON.stringify(watch(['date_from', 'date_to', 'shops', 'status'])), status]);

  useEffect(() => {
    navigate(location.pathname, { replace: true });

    axios.get('/orders/filters').then(res => {
      setData(res.data);
    });
  }, []);

  const resetMarked = () => {
    if ($(".form-label-checkbox .checkbox.mark-all").is(":checked")) {
      $(".form-label-checkbox .checkbox.mark-all").click();
    }
    $(".form-label-checkbox .checkbox.list").each(function (index) {
      if ($(this).is(':checked') == true) {
        $(this).click();
      }
    });
    setBulkArray([]);
  }

  const bulkStatusChange = (status) => {
    status !== '' &&
    swal({
      title: "Are you sure?",
      text: `You want to change status on marked user?`,
      icon: "warning",
      buttons: true,
      dangerMode: true,
      confirm: {
        text: "Yes",
        value: true,
        visible: true,
        className: "",
        closeModal: true
      }
    }).then((result) => {
      if (result === true) {
        axios.post('/orders/several-update', {
          orders: bulkArray,
          value: status,
        })
          .then(function (res) {
            if (res.status == 200) {
              swal(`Status changed successfully!`, {
                icon: "success",
              });
              setBulkArray([])
              $('#orders').DataTable().draw(false);
            }
          })
          .catch(function (error) {
            if (error.response) {
              console.log(error.response.data.errors);
            }
          });
      }
    });
  }

  const exportOrders = () => {
    axios.get('exports/orders', {
      params: getValues(),
      responseType: 'blob',
    }).then(res => {
      downloadBlob(res.data, 'orders.xlsx');
    });
  }

  const downloadSalesReport = () => {
    axios.get('exports/sales', {
      params: getValues(),
      responseType: 'blob',
    }).then(res => {
      downloadBlob(res.data, 'sales.xlsx');
    });
  }

  const downloadSalesWithHistoryReport = () => {
    axios.get('exports/sales-with-history', {
      params: getValues(),
      responseType: 'blob',
    }).then(res => {
      downloadBlob(res.data, 'sales.xlsx');
    });
  }

  const renderStatus = (status) => {
    let badgeColor;
    let badgeIcon;
    switch (status) {
      case "Pending":
        badgeColor = "warning pending";
        badgeIcon = '<i class="fas far fa-question-circle text-warning"></i>';
        break;
      case "Active":
        badgeColor = "success active";
        badgeIcon = '<i class="far fa-check-circle text-success"></i>';
        break;
      case "Canceled":
        badgeColor = "danger canceled";
        badgeIcon = '<i class="fas fa-ban text-danger"></i>';
        break;
      case "Delivered":
        badgeColor = "primary delivered";
        badgeIcon = '<i class="fas fa-map-marker-alt text-primary"></i>';
        break;
      case "Refund":
        badgeColor = "info refund";
        badgeIcon = '<i class="fas fa-comment-dollar text-info"></i>';
        break;
      case "Ready_for_shipment":
        badgeColor = "success shipped opacity-75";
        badgeIcon = '<i class="fas fa-truck text-success"></i>';
        break;
      case "Shipped":
        badgeColor = "success shipped opacity-75";
        badgeIcon = '<i class="fas fa-truck text-success"></i>';
        break;
      default:
        badgeColor = "-";
        badgeIcon = "";
    }
    return {color: badgeColor, icon: badgeIcon};
  }

  return (<>
    <div>
      <div className="row orders-filters">

        {
          <ReactSelectInput
            label="Status"
            inputClassName={`col-xxl-3 col-lg-6 mb-5${status ? " d-none" : ""}`}
            className="fancy-scroll"
            name="status"
            placeholder="Choose"
            defaultValue={statusState}
            register={register}
            options={data?.statuses}
            control={control}
          />
        }

        <ReactSelectInput
          label="Payment Status"
          inputClassName={`col-xxl-3 col-lg-6 mb-5${status ? " d-none" : ""}`}
          className="fancy-scroll"
          name="payment_status"
          placeholder="Choose"
          defaultValue={statusState}
          register={register}
          options={data?.paymentStatuses}
          control={control}
        />

        <DateInput
          label="Date from - mm/dd/yyyy"
          name="date_from"
          parentClasses="col-xxl-3 col-lg-6 mb-5"
          labelClasses="fs-7"
          title="mm/dd/yyyy"
          register={register}
        />

        <DateInput
          label="Date to - mm/dd/yyyy"
          name="date_to"
          parentClasses="col-xxl-3 col-lg-6 mb-5"
          labelClasses="fs-7"
          title="mm/dd/yyyy"
          register={register}
        />
        {
          isAdmin &&
          <ReactMultiSelectInput
            label="Sellers"
            parentClasses="col-xxl-3 col-lg-6 mb-5"
            name="shops"
            placeholder="Choose"
            values={data?.shops}
            control={control}
          />
        }

      </div>
      {
        isAdmin && (
          <div className="d-block text-right mb-5">

            <button
              type="button"
              className='btn btn-lg btn-primary mb-5 mr-2'
              onClick={() => navigate('/orders/create')}
            >
              <span className="indicator-label">
                <i className="fa fa-plus"></i>
                Add
              </span>
            </button>

            <button
              type="button"
              className='btn btn-lg btn-primary mb-5 ml-2'
              onClick={exportOrders}
            >
              <span className="indicator-label">
                <i className="fa fa-download"></i>
                Export
              </span>
            </button>
            <button
              type="button"
              className='btn btn-lg btn-primary mb-5 ml-3'
              onClick={downloadSalesReport}
            >
              <span className="indicator-label">
                <i className="fa fa-download"></i>
                Download Sales Report
              </span>
            </button>
            <button
              type="button"
              className='btn btn-lg btn-primary mb-5 ml-3'
              onClick={downloadSalesWithHistoryReport}
            >
              <span className="indicator-label">
                <i className="fa fa-download"></i>
                Sales With History
              </span>
            </button>
            <div className={`marked-actions orders${buttonIsDisabled ? " d-none" : ""}`}>
              <select className="form-control form-control-lg form-control-solid border-2 w-auto fs-7 fw-bold"
                      data-control="select2"
                      onChange={e => bulkStatusChange(e.target.value)}
                      value={''}
              >
                <option value=''>Change marked status</option>
                {data?.statuses?.map((item) => <option value={item.id} key={item.id}>{item.name}</option>)}
              </select>
            </div>
          </div>
        )
      }
      <table id="orders" className="table align-middle table-row-dashed fs-6 gy-5">
        <thead>
        <tr className="text-start text-gray-400 fw-bolder fs-7 text-uppercase gs-0">
          <th></th>
          <th>ID</th>
          <th>Customer</th>
          <th>Delivery Phone</th>
          <th>Customer Email</th>
          <th>Status</th>
          <th>Total</th>
          <th>Date</th>
          <th>Modified</th>
          <th>Warranty</th>
          <th>Refund</th>
          <th>Actions</th>
        </tr>
        </thead>
        <tbody className="text-gray-600 fw-bold">
        </tbody>
      </table>
    </div>
  </>);
}